import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#AddModeleModal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }),
  /*#__PURE__*/_createTextVNode(" Ajouter un modele ")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Nom "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Description "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Marque "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Catégorie "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
    }, "Actions")
  ])
], -1)
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = { class: "badge badge-outline-danger text-outline-primary" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete icon-position" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_23 = { class: "dropdown" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_25 = { class: "dropdown-menu" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_29 = { key: 1 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_32 = { key: 2 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_35 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddModeleModal = _resolveComponent("AddModeleModal")!
  const _component_AddNewCategorieModal = _resolveComponent("AddNewCategorieModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.checkPermission('AddModel'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un modele"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _hoisted_7
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modeles, (modele, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(modele.nom), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(modele.description), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(modele?.marque?.name), 1),
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modele.modelecategories, (modelecategorie) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: modelecategorie.id,
                          class: "badge-container"
                        }, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, [
                              _createTextVNode(_toDisplayString(modelecategorie.categorie.name) + " ", 1),
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "tag-delete-link text-outline-danger",
                                onClick: ($event: any) => (_ctx.suppression(modelecategorie.id, modele?.modelecategories, 'modelecategorie', `la catégorie ${modelecategorie.categorie.name}`))
                              }, _hoisted_21, 8, _hoisted_19)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("ul", _hoisted_25, [
                        (_ctx.checkPermission('EditModel'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AddModeleModal",
                                onClick: ($event: any) => (_ctx.moddifier(modele))
                              }, [
                                _hoisted_28,
                                _createTextVNode(" Modifier ")
                              ], 8, _hoisted_27)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('AddModeleCategorie'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "#",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AddNewCategorieModal",
                                onClick: ($event: any) => (_ctx.openAddNewCategorieModal(modele))
                              }, [
                                _hoisted_31,
                                _createTextVNode(" Ajouter de (s) catégorie (s) ")
                              ], 8, _hoisted_30)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('DeleteModele'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.suppression(modele.id,_ctx.modeles,'models','modele'))
                              }, [
                                _hoisted_34,
                                _createTextVNode(" Supprimer ")
                              ], 8, _hoisted_33)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddModeleModal, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger
    }, null, 8, ["item", "onClose"]),
    _createVNode(_component_AddNewCategorieModal, {
      selectedModele: _ctx.selectedModele,
      selectedModeleId: _ctx.selectedModeleId
    }, null, 8, ["selectedModele", "selectedModeleId"])
  ], 64))
}